import { L } from '@lang';
import { Trans } from 'react-i18next';
import { imageGetters } from '../../helpers/imageGetters';
import { Header } from '../../widgets/Header';
import { Instruction, InstallPage } from '../../shared/ui';

export function PwaInstallSafari() {
  return (
    <InstallPage>
      <Header />
      <Instruction>
        <Instruction.Item
          title={L.t('pwa_install_safari_safari_menu_dots_title')}
          srcSet={imageGetters.iosSteps('safari-menu-dots')}
          aspectRatio={540 / 148}
        />
        <Instruction.Item
          title={<Trans i18n={L.i18n} i18nKey="pwa_install_safari_share_button_title" components={{ b: <b /> }} />}
          srcSet={imageGetters.iosSteps('share-button')}
          aspectRatio={540 / 148}
        />
        <Instruction.Item
          title={<Trans i18n={L.i18n} i18nKey="pwa_install_safari_show_more_button_title" components={{ b: <b /> }} />}
          srcSet={imageGetters.iosSteps('show-more-button')}
          aspectRatio={540 / 148}
        />
        <Instruction.Item
          title={
            <Trans i18n={L.i18n} i18nKey="pwa_install_safari_add_to_home_screen_title" components={{ b: <b /> }} />
          }
          srcSet={imageGetters.iosSteps('add-to-home-screen')}
          aspectRatio={540 / 148}
        />
        <Instruction.Item
          title={L.t('pwa_install_safari_add_to_home_confirm_title')}
          srcSet={imageGetters.iosSteps('add-to-home-confirm')}
          aspectRatio={540 / 148}
        />
        <Instruction.Item
          title={L.t('pwa_install_safari_notifications_permission_title')}
          srcSet={imageGetters.iosSteps('notifications-permission')}
          aspectRatio={540 / 148}
        />
        <Instruction.Item
          title={L.t('pwa_install_safari_push_notification_title')}
          srcSet={imageGetters.iosSteps('push-notification')}
          aspectRatio={540 / 148}
        />
      </Instruction>
    </InstallPage>
  );
}
